import { OrganizationSettingsPage } from '../../features/organization-settings/pages';

export default function Organization() {
  return <OrganizationSettingsPage />;
}
